module.exports = function() {
  return new Worker(__webpack_public_path__ + "a5e9fee80233f9aaf49b.worker.js");
};